import { createFileRoute } from '@tanstack/react-router'

import { CustomerPageWrapper } from '@/components/molecules/customer-page-wrapper'
import PageHeader from '@/components/molecules/shared/page-header'
import { AccountingDocuments } from '@/features/accounting/pages/documents'
import Head from '@/lib/navigation/head'

function DocumentsRoute() {
  return (
    <>
      <Head>
        <title>Year-end documents | Nonresident Tax</title>
      </Head>
      <CustomerPageWrapper stickyHeader={<PageHeader title="Year-end documents" sticky />}>
        <AccountingDocuments />
      </CustomerPageWrapper>
    </>
  )
}

export const Route = createFileRoute('/_shell/accounting/documents')({
  component: DocumentsRoute,
})
